import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["listing", "purchaseOffer", "counterOfferForID", "visible", "onCancel"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { InfoCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { AppContext } from "../DixuApp/DixuApp";
import DixuButton from "../DixuButton/DixuButton";
import DixuCheckbox from "../DixuCheckbox/DixuCheckbox";
import DixuCollapse from "../DixuCollapse/DixuCollapse";
import DixuDatePicker from "../DixuDatePicker/DixuDatePicker";
import DixuDivider from "../DixuDivider/DixuDivider";
import DixuForm, { validators } from "../DixuForm/DixuForm";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuInput, { DixuTextArea } from "../DixuInput/DixuInput";
import DixuInputNumber from "../DixuInputNumber/DixuInputNumber";
import DixuLink from "../DixuLink/DixuLink";
import DixuModal from "../DixuModal/DixuModal";
import DixuNotification from "../DixuNotification/DixuNotification";
import DixuPDFViewer from "../DixuPDFViewer/DixuPDFViewer";
import DixuPlacesAutocomplete from "../DixuPlacesAutocomplete/DixuPlacesAutocomplete";
import DixuRadio from "../DixuRadio/DixuRadio";
import DixuRealtorInfo from "../DixuRealtorInfo/DixuRealtorInfo";
import DixuSelect from "../DixuSelect/DixuSelect";
import DixuStepFlow from "../DixuStepFlow/DixuStepFlow";
import DixuTabs from "../DixuTabs/DixuTabs";
import DixuText from "../DixuText/DixuText";
import DixuTimePicker from "../DixuTimePicker/DixuTimePicker";
import DixuTitle from "../DixuTitle/DixuTitle";
import useAfterInitialRender from "../../hooks/useAfterInitialRender";
import useConfirmUnload from "../../hooks/useConfirmUnload";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import moment from 'moment-timezone';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { get, getCounterPurchaseOfferDraft, getErrorDescription, getPurchaseOffer, getPurchaseOfferPreviewPDF, redirect, saveCounterPurchaseOfferDraft, savePurchaseOfferDraft } from "../../services/ApiService";
import { disableFutureDates, disablePastDatesAllowToday } from "../../utils/DateTimeUtils";
import { ApartmentPurchaseOfferDocumentTypes, BudgetConfirmedTypes, HumidityInspectionPayerType, LISTING_TYPE, OFFER_STATUS } from "../../utils/DixuConstants";
import { getFullStreetAddress, isDixuEasy, isRealtorListing } from "../../utils/DixuListingUtils";
import { parseBiddingValidity } from "../../utils/DixuPurchaseOfferUtils";
import { isStorybookEnv } from "../../utils/EnvUtils";
import { formatPrice } from "../../utils/MoneyUtils";
const CreatePurchaseOfferContext = /*#__PURE__*/React.createContext({
  listing: undefined,
  purchaseOffer: undefined,
  counterOfferForID: undefined,
  isCounterOffer: undefined,
  isBidding: undefined,
  form: undefined,
  getRealtorInfo: undefined,
  purchaseOfferPDFData: undefined,
  flow: undefined
});
const dateToFinnishDate = incoming => moment.tz(incoming, 'Europe/Helsinki').format('YYYY-MM-DD');
const deserializePurchaseOffer = function () {
  let purchaseOffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let listing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, purchaseOffer), {}, {
    debtlessPriceOffer: purchaseOffer.debtlessPriceOffer ? purchaseOffer.debtlessPriceOffer : listing ? listing.debtFreePrice : 0,
    salesContractSigningDateDeadline: purchaseOffer.salesContractSigningDateDeadline && dateToFinnishDate(purchaseOffer.salesContractSigningDateDeadline),
    apartmentControlChangeDateDeadline: purchaseOffer.apartmentControlChangeDateDeadline && dateToFinnishDate(purchaseOffer.apartmentControlChangeDateDeadline),
    apartmentControlChangeTimeDeadline: purchaseOffer.apartmentControlChangeTimeDeadline && moment(purchaseOffer.apartmentControlChangeTimeDeadline),
    maintenanceChargesSellerLastDay: purchaseOffer.maintenanceChargesSellerLastDay && dateToFinnishDate(purchaseOffer.maintenanceChargesSellerLastDay),
    maintenanceChargesBuyerFirstDay: purchaseOffer.maintenanceChargesBuyerFirstDay && dateToFinnishDate(purchaseOffer.maintenanceChargesBuyerFirstDay),
    loanAcquiredByDate: purchaseOffer.loanAcquiredByDate && dateToFinnishDate(purchaseOffer.loanAcquiredByDate),
    ownApartmentSaleByDate: purchaseOffer.ownApartmentSaleByDate && dateToFinnishDate(purchaseOffer.ownApartmentSaleByDate),
    getToKnowDate: purchaseOffer.getToKnowDate && dateToFinnishDate(purchaseOffer.getToKnowDate),
    offerValidityDeadline: purchaseOffer.offerValidityDeadline && dateToFinnishDate(purchaseOffer.offerValidityDeadline),
    offerValidityTimeDeadline: purchaseOffer.offerValidityTimeDeadline && moment(purchaseOffer.offerValidityDeadline),
    status: purchaseOffer.status || 'DRAFT',
    buyers: [purchaseOffer?.primaryBuyer, ...(purchaseOffer?.additionalBuyers || [])].filter(Boolean),
    buyerVisitedPropertyOn: purchaseOffer?.buyerVisitedPropertyOn || [null]
  }, parseBiddingValidity(purchaseOffer));
};
const serializePurchaseOffer = purchaseOffer => {
  // BiddingOffervalidity is stored in 2 separate fields in UI (time amount, time unit)
  const {
    biddingOfferValidityTimeAmount,
    biddingOfferValidityTimeUnit
  } = purchaseOffer;
  const biddingOfferValidity = biddingOfferValidityTimeAmount && biddingOfferValidityTimeUnit ? [biddingOfferValidityTimeAmount, biddingOfferValidityTimeUnit].join(' ') : undefined;
  const offerValidityDeadline = moment(purchaseOffer.offerValidityDateDeadline).set('hour', moment(purchaseOffer.offerValidityTimeDeadline).hour()).set('minute', moment(purchaseOffer.offerValidityTimeDeadline).minute()).set('second', 0);
  return _objectSpread(_objectSpread({}, purchaseOffer), {}, {
    biddingOfferValidity,
    offerValidityDeadline,
    primaryBuyer: purchaseOffer.buyers[0],
    additionalBuyers: purchaseOffer.buyers.slice(1)
  });
};
const DateTimeFields = _ref => {
  let {
    wrapperItemProps,
    dateItemProps,
    datePickerProps,
    timeItemsProps,
    timePickerProps
  } = _ref;
  return /*#__PURE__*/React.createElement(DixuForm.Item, wrapperItemProps, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: [8, 8]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 11
  }, /*#__PURE__*/React.createElement(DixuForm.Item, _objectSpread({}, dateItemProps), /*#__PURE__*/React.createElement(DixuDatePicker, _objectSpread({
    width: '100%'
  }, datePickerProps)))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 2
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle"
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-9",
    align: "center"
  }, "klo")))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 11
  }, /*#__PURE__*/React.createElement(DixuForm.Item, _objectSpread({}, timeItemsProps), /*#__PURE__*/React.createElement(DixuTimePicker, _objectSpread({
    width: '100%'
  }, timePickerProps))))));
};
const Step1 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    form,
    isCounterOffer,
    listing
  } = useContext(CreatePurchaseOfferContext);
  return /*#__PURE__*/React.createElement(DixuForm.List, {
    name: "buyers"
  }, (fields, _ref2) => {
    let {
      add,
      remove
    } = _ref2;
    const buyerCount = fields.length;
    const buyerInfo = fields.map(field => {
      const {
        key,
        name,
        fieldKey
      } = field;
      const getFieldProps = fieldName => {
        return {
          name: [name, fieldName],
          fieldKey: [fieldKey, fieldName]
        };
      };
      const commonInputProps = {
        disabled: isCounterOffer
      };
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: key
      }, /*#__PURE__*/React.createElement(DixuForm.Section, {
        title: /*#__PURE__*/React.createElement(DixuRow, {
          align: "middle",
          gutter: 8,
          wrap: false
        }, /*#__PURE__*/React.createElement(DixuCol, null, t('listing:PurchaseOffer.BuyerDetails')), buyerCount > 1 && !isCounterOffer && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuButton, {
          type: "link",
          modifierType: "circle",
          icon: /*#__PURE__*/React.createElement(MinusCircleOutlined, null),
          block: false,
          onClick: () => remove(name)
        })))
      }, /*#__PURE__*/React.createElement(DixuRow, {
        gutter: [16, 8]
      }, /*#__PURE__*/React.createElement(DixuCol, {
        xs: 24,
        md: 12
      }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('name'), {
        label: t('common:FullName'),
        rules: [{
          required: true
        }]
      }), /*#__PURE__*/React.createElement(DixuInput, commonInputProps))), !isCounterOffer && /*#__PURE__*/React.createElement(DixuCol, {
        xs: 24,
        md: 12
      }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('ssn'), {
        label: t('common:Ssn'),
        rules: [{
          required: true
        }, {
          validator: validators.ssn({
            invalidText: t('common:Validation.NotValidSsn')
          })
        }]
      }), /*#__PURE__*/React.createElement(DixuInput, commonInputProps))), isRealtorListing(listing) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('sharePercentage'), {
        wrapperCol: {
          span: 24
        },
        label: t('listing:PurchaseOffer.ShareOfOwnership'),
        rules: [{
          required: true
        }]
      }), /*#__PURE__*/React.createElement(DixuInputNumber, {
        min: 0,
        max: 100
      }))), /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('emailMarketingConsent'), {
        valuePropName: "checked",
        wrapperCol: {
          span: 24
        }
      }), /*#__PURE__*/React.createElement(DixuCheckbox, null, t('listing:PurchaseOffer.ProposerMarketingConsent'))))))), /*#__PURE__*/React.createElement(DixuForm.Section, {
        grid: true
      }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('address'), {
        label: t('common:StreetAddress'),
        rules: [{
          required: true
        }]
      }), /*#__PURE__*/React.createElement(DixuPlacesAutocomplete, {
        inputProps: commonInputProps,
        fetchAdditionalInfo: false,
        onChangeSideEffects: data => {
          const {
            city,
            postalCode
          } = data;
          const newBuyers = [...form.getFieldValue('buyers')];
          newBuyers.splice(name, 1, _objectSpread(_objectSpread({}, form.getFieldValue(['buyers', name])), {}, {
            postnumber: postalCode,
            postoffice: city
          }));
          form.setFieldsValue({
            buyers: newBuyers
          });
        }
      })), /*#__PURE__*/React.createElement(DixuForm.Section.EmptySlot, null), /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('postnumber'), {
        label: t('common:PostalCode'),
        rules: [{
          required: true
        }]
      }), /*#__PURE__*/React.createElement(DixuInput, commonInputProps)), /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('postoffice'), {
        label: t('common:PostOffice'),
        rules: [{
          required: true
        }]
      }), /*#__PURE__*/React.createElement(DixuInput, commonInputProps))), /*#__PURE__*/React.createElement(DixuForm.Section, {
        grid: true
      }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('email'), {
        label: t('common:Email'),
        rules: [{
          required: true,
          type: 'email'
        }]
      }), /*#__PURE__*/React.createElement(DixuInput, _extends({
        type: "email"
      }, commonInputProps))), /*#__PURE__*/React.createElement(DixuForm.Section.EmptySlot, null), /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, getFieldProps('tel'), {
        label: t('common:Phone'),
        rules: [{
          required: true
        }]
      }), /*#__PURE__*/React.createElement(DixuInput, _extends({
        type: "tel"
      }, commonInputProps)))));
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, buyerInfo, !isCounterOffer && /*#__PURE__*/React.createElement(DixuButton, {
      type: "outline",
      onClick: () => add()
    }, t('listing:PurchaseOffer.AddAnotherBuyer')));
  });
};
const Step2 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    listing,
    form,
    isCounterOffer
  } = useContext(CreatePurchaseOfferContext);
  const {
    bidding
  } = listing || {};
  const {
    debtlessStartPrice
  } = bidding || {};
  const needsPEP = isRealtorListing(listing);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isCounterOffer && /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer:OfferPrice'),
    grid: true
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "debtlessPriceOffer",
    label: t('listing:PurchaseOffer.YourOfferedDebtlessPrice'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInputNumber, {
    width: "100%",
    type: "money",
    hideHandlers: true,
    min: debtlessStartPrice || 0
  }))), isCounterOffer && /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer:OfferedDebtlessPrice'),
    grid: true
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "debtlessPriceOffer",
    label: t('listing:PurchaseOffer:YourCounterOffer'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInputNumber, {
    width: "100%",
    type: "money",
    hideHandlers: true,
    min: 0
  }))), !isCounterOffer && needsPEP && /*#__PURE__*/React.createElement(DixuForm.Section, null, /*#__PURE__*/React.createElement(DixuForm.List, {
    name: "buyers"
  }, fields => {
    return fields.map((field, index) => {
      const {
        key,
        name,
        fieldKey
      } = field;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: key
      }, /*#__PURE__*/React.createElement(DixuForm.Item, {
        name: [name, 'isPep'],
        fieldKey: [fieldKey, 'isPep'],
        label: t('listing:PurchaseOffer.NeedsPepDetails', {
          name: form.getFieldValue(['buyers', index, 'name'])
        }),
        rules: [{
          required: true
        }]
      }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
        vertical: true,
        options: [{
          value: true,
          label: t('common:Yes')
        }, {
          value: false,
          label: t('common:No')
        }]
      })), /*#__PURE__*/React.createElement(DixuForm.Item, {
        noStyle: true,
        shouldUpdate: [['buyers', index, 'isPep']]
      }, () => {
        const {
          buyers
        } = form.getFieldsValue(true);
        const {
          isPep
        } = buyers?.[index] || {};
        if (!isPep) {
          return null;
        }
        return /*#__PURE__*/React.createElement(DixuForm.Item, {
          name: [name, 'isPepInfo'],
          fieldKey: [fieldKey, 'isPepInfo'],
          label: t('listing:PurchaseOffer.PepDetails'),
          rules: [{
            required: true
          }]
        }, /*#__PURE__*/React.createElement(DixuInput.TextArea, {
          autoSize: {
            minRows: 3
          }
        }));
      }));
    });
  })), /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.TransactionTerms')
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    noStyle: true,
    shouldUpdate: "debtlessPriceOffer"
  }, () => {
    const {
      debtlessPriceOffer
    } = form.getFieldsValue(true);
    return /*#__PURE__*/React.createElement(DixuText, {
      font: "2",
      color: "2-9",
      block: true
    }, t('listing:PurchaseOffer.DebtlessPrice', {
      price: formatPrice(debtlessPriceOffer)
    }));
  }), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "salesContractSigningDateDeadline",
    label: t('listing:PurchaseOffer.PaymentScheduleAndWay'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuDatePicker, {
    disabledDate: disablePastDatesAllowToday
  })), /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-9",
    block: true
  }, t('listing:PurchaseOffer.WhenToPay'))));
};
const Step3 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    listing,
    getRealtorInfo,
    form
  } = useContext(CreatePurchaseOfferContext);
  const {
    type
  } = listing || {};
  const isApartment = type === LISTING_TYPE.APARTMENT;
  return /*#__PURE__*/React.createElement(React.Fragment, null, getRealtorInfo({
    defaultOpen: true
  }), /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.OwnershipTransferTitle')
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-9"
  }, t('listing:PurchaseOffer.OwnershipTransferDetails1'))), /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t(`listing:PurchaseOffer.${isApartment ? 'ApartmentControlTitle' : 'PropertyControlTitle'}`)
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "apartmentControlChangesOn",
    rules: [{
      required: true
    }],
    label: t('listing:PurchaseOffer.ApartmentControlDetails1')
  }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
    vertical: true,
    options: ['WHEN_SOLD', 'ON_OWNERSHIP_TRANSFER', 'DATE_DEADLINE'].map(value => {
      return {
        value,
        label: t(`listing:PurchaseOffer.ApartmentControlChangesOnValues.${value}`)
      };
    })
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    noStyle: true,
    shouldUpdate: ['apartmentControlChangesOn'],
    visible: () => form.getFieldValue('apartmentControlChangesOn') === 'DATE_DEADLINE'
  }, /*#__PURE__*/React.createElement(DateTimeFields, {
    wrapperItemProps: {
      style: {
        marginBottom: 0
      }
    },
    dateItemProps: {
      name: 'apartmentControlChangesOnDateDeadline',
      rules: [{
        required: true
      }]
    },
    datePickerProps: {
      disabledDate: disablePastDatesAllowToday
    },
    timeItemsProps: {
      name: 'apartmentControlChangesOnDateDeadline',
      rules: [{
        required: true
      }]
    }
  })), /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-9",
    block: true,
    className: "m-t-16"
  }, t('listing:PurchaseOffer:ApartmentControlDetails2'))));
};
const Step4 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    getRealtorInfo
  } = useContext(CreatePurchaseOfferContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, getRealtorInfo(), /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.MaintenanceChargesTitle'),
    grid: true
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "apartmentSellerResponsibleForMaintenanceChargeUntilDate",
    label: t('listing:PurchaseOffer:MaintenanceChargesDetails'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuDatePicker, {
    width: "100%",
    disabledDate: disablePastDatesAllowToday
  })), /*#__PURE__*/React.createElement(DixuForm.Section.EmptySlot, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "apartmentSellerResponsibleForFundingChargeUntilDate",
    label: t('listing:PurchaseOffer.FundingChargeDetails'),
    rules: [{
      required: true
    }],
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement(DixuDatePicker, {
    width: "100%",
    disabledDate: disablePastDatesAllowToday
  })), /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-9",
    block: true,
    className: "m-t-8"
  }, t('listing:PurchaseOffer.MaintenanceChargesDetails3')))));
};
const Step5 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    form,
    getRealtorInfo,
    isCounterOffer
  } = useContext(CreatePurchaseOfferContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, getRealtorInfo(), /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.SalesPreconditions'),
    wrapperRow: {
      gutter: [0, 8]
    },
    wrapperCol: {
      span: 24
    }
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 8]
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "loanAcquiredByBoolean",
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(DixuCheckbox, {
    disabled: isCounterOffer
  }, t('listing:PurchaseOffer:LoanBy')))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    shouldUpdate: "loanAcquiredByBoolean"
  }, () => {
    const {
      loanAcquiredByBoolean
    } = form.getFieldsValue(true);
    const disabled = !loanAcquiredByBoolean || isCounterOffer;
    return /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: "loanAcquiredByDate",
      rules: [{
        required: !disabled
      }]
    }, /*#__PURE__*/React.createElement(DixuDatePicker, {
      width: "250",
      disabled: disabled,
      disabledDate: disablePastDatesAllowToday
    }));
  }))), /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "conditionCheckBoolean",
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(DixuCheckbox, null, t('listing:PurchaseOffer:ConditionCheck')))), /*#__PURE__*/React.createElement(DixuForm.Item, {
    shouldUpdate: "conditionCheckBoolean",
    noStyle: true
  }, () => {
    const {
      conditionCheckBoolean
    } = form.getFieldsValue(true);
    if (!conditionCheckBoolean) {
      return null;
    }
    return /*#__PURE__*/React.createElement(DixuCol, {
      span: 24
    }, /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: "conditionCheckValue",
      shouldUpdate: "conditionCheckBoolean",
      rules: [{
        required: true
      }],
      label: t('listing:PurchaseOffer:WhoIsResponsibleForConditionCheckCosts')
    }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
      options: ['SELLER', 'BUYER', 'SPLIT'].map(value => {
        return {
          value,
          label: t(`listing:PurchaseOffer.CONDITION_CHECK.${value}`)
        };
      })
    })));
  })), /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "humidityInspectionBoolean",
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(DixuCheckbox, null, t('listing:PurchaseOffer:HumidityInspection')))), /*#__PURE__*/React.createElement(DixuForm.Item, {
    shouldUpdate: "humidityInspectionBoolean",
    noStyle: true
  }, () => {
    const humidityInspectionBoolean = form.getFieldValue('humidityInspectionBoolean');
    if (!humidityInspectionBoolean) {
      return null;
    }
    return /*#__PURE__*/React.createElement(DixuCol, {
      span: 24
    }, /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: "humidityInspectionValue",
      shouldUpdate: "humidityInspectionBoolean",
      rules: [{
        required: true
      }],
      label: t('listing:PurchaseOffer:WhoIsResponsibleForHumidityInspectionCosts')
    }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
      options: Object.values(HumidityInspectionPayerType)?.map(value => {
        return {
          value,
          label: t(`listing:PurchaseOffer.HUMIDITY_INSPECTION.${value}`)
        };
      })
    })));
  })), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 8]
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "ownApartmentSaleByBoolean",
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(DixuCheckbox, {
    disabled: isCounterOffer
  }, t('listing:PurchaseOffer:OwnApartmentSale')))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    shouldUpdate: "ownApartmentSaleByBoolean"
  }, () => {
    const {
      ownApartmentSaleByBoolean
    } = form.getFieldsValue(true);
    const disabled = !ownApartmentSaleByBoolean || isCounterOffer;
    return /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: "ownApartmentSaleByDate",
      rules: [{
        required: !disabled
      }]
    }, /*#__PURE__*/React.createElement(DixuDatePicker, {
      width: "250",
      disabled: disabled,
      disabledDate: disablePastDatesAllowToday
    }));
  }))), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 8]
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "digitalAndPopulationAgencyPermissionBoolean",
    valuePropName: "checked"
  }, /*#__PURE__*/React.createElement(DixuCheckbox, {
    disabled: isCounterOffer
  }, t('listing:PurchaseOffer:DigitalAndPopulationAgencyPermissionBy')))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    shouldUpdate: "digitalAndPopulationAgencyPermissionBoolean"
  }, () => {
    const {
      digitalAndPopulationAgencyPermissionBoolean
    } = form.getFieldsValue(true);
    const disabled = !digitalAndPopulationAgencyPermissionBoolean || isCounterOffer;
    return /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: "digitalAndPopulationAgencyPermissionByDate",
      rules: [{
        required: !disabled
      }]
    }, /*#__PURE__*/React.createElement(DixuDatePicker, {
      width: "250",
      disabled: disabled,
      disabledDate: disablePastDatesAllowToday
    }));
  }))), /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "otherPrerequisites",
    label: t('listing:PurchaseOffer.OtherPreconditions')
  }, /*#__PURE__*/React.createElement(DixuInput.TextArea, {
    autoSize: {
      minRows: 3
    }
  }))))));
};
const Step6 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    form,
    getRealtorInfo,
    isCounterOffer
  } = useContext(CreatePurchaseOfferContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, getRealtorInfo(), /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.ContractualPenaltyTitle')
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-9",
    block: true
  }, t('listing:PurchaseOffer.ContractualPenaltyDetails'))));
};
const Step7 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    form,
    listing,
    isCounterOffer
  } = useContext(CreatePurchaseOfferContext);
  const {
    type
  } = listing || {};
  const validateArrayRequired = async (_rule, value) => {
    if (value !== [null] && value && Array.isArray(value) && value?.length > 0 && value?.filter(Boolean)?.length > 0) {
      return Promise.resolve();
    }
    return Promise.reject(t('common:Validation.AddAtleastOneDate'));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.GetToKnowApartmentTitle')
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "buyerHasGotToKnowProperty",
    label: t('listing:PurchaseOffer.ApartmentInspection'),
    style: {
      marginBottom: 0
    },
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
    disabled: isCounterOffer,
    vertical: true,
    options: [{
      value: 'BY_VIRTUAL_PRESENTATION_AND_PHOTOS',
      label: t('listing:PurchaseOffer.VirtualPresentationAndPhotos')
    }, {
      value: 'BY_VISITING',
      label: t('listing:PurchaseOffer.BuyerInspected')
    }]
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    shouldUpdate: ['buyerHasGotToKnowProperty'],
    visible: () => form.getFieldValue('buyerHasGotToKnowProperty')?.includes('BY_VISITING'),
    noStyle: true
  }, /*#__PURE__*/React.createElement(Form.List, {
    name: "buyerVisitedPropertyOn",
    rules: [{
      required: true
    }, {
      validator: validateArrayRequired
    }]
  }, (fields, _ref3, _ref4) => {
    let {
      add,
      remove
    } = _ref3;
    let {
      errors
    } = _ref4;
    return /*#__PURE__*/React.createElement(React.Fragment, null, fields.map((field, index) => /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: [field.name],
      noStyle: true
    }, /*#__PURE__*/React.createElement(DixuDatePicker, {
      disabled: isCounterOffer,
      placeholder: t('listing:PurchaseOffer.InspectionDate'),
      disabledDate: disableFutureDates,
      withoutTime: true,
      width: 150,
      style: {
        marginRight: 5,
        marginTop: 5
      },
      onChange: newVal => {
        if (!newVal && index !== 0) {
          remove(index);
        }
      }
    }))), /*#__PURE__*/React.createElement(DixuButton, {
      style: {
        paddingLeft: 0
      },
      type: "link",
      icon: /*#__PURE__*/React.createElement(PlusOutlined, null),
      onClick: () => add(null)
    }, t('listing:PurchaseOffer.AddGetToKnowDate')), /*#__PURE__*/React.createElement(Form.ErrorList, {
      errors: errors
    }), /*#__PURE__*/React.createElement(DixuCol, {
      className: "m-t-10"
    }, /*#__PURE__*/React.createElement(DixuDivider, null)));
  }))))), /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.BuyerHasInspectedDocuments')
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm.List, {
    name: "propertyDocuments"
  }, (fields, _ref5, _ref6) => {
    let {
      add,
      remove
    } = _ref5;
    let {
      errors
    } = _ref6;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: 15
      }
    }, fields?.map(field => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, field, {
      name: [field.name, 'selected'],
      fieldKey: [field.fieldKey, 'selected'],
      valuePropName: "checked",
      noMargin: true
    }), /*#__PURE__*/React.createElement(DixuCheckbox, null, t(`listing:PurchaseOffer.OfferDocumentTypeValues.${form?.getFieldValue('propertyDocuments')[field.name]?.documentName}`), /*#__PURE__*/React.createElement("div", {
      className: "m-t-5 m-b-5"
    }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, field, {
      name: [field.name, 'date'],
      fieldKey: [field.fieldKey, 'date'],
      shouldUpdateFunction: (prev, next) => prev?.propertyDocuments?.[field.name] !== next?.propertyDocuments?.[field.name],
      visible: () => ![ApartmentPurchaseOfferDocumentTypes.OTHER_DOCUMENTS, ApartmentPurchaseOfferDocumentTypes.FINANCIAL_STATEMENTS, ApartmentPurchaseOfferDocumentTypes.BUDGET].includes(form?.getFieldValue(['propertyDocuments', field.name])?.documentName) && form?.getFieldValue(['propertyDocuments', field.name])?.selected === true,
      noMargin: true
    }), /*#__PURE__*/React.createElement(DixuDatePicker, {
      withoutTime: true,
      style: {
        marginTop: 8
      },
      width: 170,
      placeholder: t('listing:PurchaseOffer.DocumentDate'),
      disabledDate: disableFutureDates
    }))), /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, field, {
      name: [field.name, 'details'],
      fieldKey: [field.fieldKey, 'details'],
      shouldUpdateFunction: (prev, next) => prev?.propertyDocuments?.[field.name] !== next?.propertyDocuments?.[field.name],
      visible: () => form?.getFieldValue(['propertyDocuments', field.name])?.documentName === ApartmentPurchaseOfferDocumentTypes.OTHER_DOCUMENTS && form?.getFieldValue(['propertyDocuments', field.name])?.selected === true,
      noStyle: true
    }), /*#__PURE__*/React.createElement(DixuTextArea, {
      width: 150
    })), /*#__PURE__*/React.createElement(DixuForm.Item, {
      shouldUpdateFunction: (prev, next) => prev?.propertyDocuments?.[field.name] !== next?.propertyDocuments?.[field.name],
      visible: () => form?.getFieldValue(['propertyDocuments', field.name])?.documentName === ApartmentPurchaseOfferDocumentTypes.FINANCIAL_STATEMENTS && form?.getFieldValue(['propertyDocuments', field.name])?.selected === true,
      noStyle: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "m-b-10 m-t-5"
    }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, field, {
      name: [field.name, 'financialStatementYear'],
      fieldKey: [field.fieldKey, 'financialStatementYear'],
      inline: true
    }), /*#__PURE__*/React.createElement(DixuDatePicker, {
      picker: "year",
      width: 150,
      style: {
        marginTop: 8
      },
      placeholder: t('listing:PurchaseOffer.FromYear'),
      disabledDate: disableFutureDates
    })))), /*#__PURE__*/React.createElement(DixuForm.Item, {
      shouldUpdateFunction: (prev, next) => prev?.propertyDocuments?.[field.name] !== next?.propertyDocuments?.[field.name],
      visible: () => form?.getFieldValue(['propertyDocuments', field.name])?.documentName === ApartmentPurchaseOfferDocumentTypes.BUDGET && form?.getFieldValue(['propertyDocuments', field.name])?.selected === true,
      noStyle: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "m-b-5"
    }, /*#__PURE__*/React.createElement(DixuForm.Item, {
      inline: true
    }, /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, field, {
      name: [field.name, 'budgetYear'],
      fieldKey: [field.fieldKey, 'budgetYear']
    }), /*#__PURE__*/React.createElement(DixuDatePicker, {
      picker: "year",
      withoutTime: true,
      placeholder: t('listing:PurchaseOffer.FromYear'),
      style: {
        marginTop: 8
      },
      disabledDate: disableFutureDates
    })), /*#__PURE__*/React.createElement(DixuForm.Item, _extends({}, field, {
      name: [field.name, 'budgetConfirmed'],
      fieldKey: [field.fieldKey, 'budgetConfirmed'],
      inline: true
    }), /*#__PURE__*/React.createElement(DixuRadio.Group, {
      grouped: true
    }, /*#__PURE__*/React.createElement(DixuRadio, {
      value: BudgetConfirmedTypes.CONFIRMED
    }, t('listing:PurchaseOffer.BudgetConfirmedTypes.CONFIRMED')), /*#__PURE__*/React.createElement(DixuRadio, {
      value: BudgetConfirmedTypes.UNCONFIRMED
    }, t('listing:PurchaseOffer.BudgetConfirmedTypes.UNCONFIRMED')))))))))))));
  }))), /*#__PURE__*/React.createElement(DixuForm.Item, {
    shouldUpdate: ['otherDocuments'],
    visible: () => !!form.getFieldValue('otherDocuments'),
    name: "otherDocuments",
    label: t('listing:PurchaseOffer.OtherDocuments'),
    style: {
      marginBottom: 0,
      marginTop: 8
    }
  }, /*#__PURE__*/React.createElement(DixuInput.TextArea, {
    autoSize: {
      minRows: 3,
      maxRows: 8
    },
    disabled: isCounterOffer
  }))));
};
const Step8 = () => {
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing', 'pdfs']);
  const {
    form,
    purchaseOfferPDFData,
    listing
  } = useContext(CreatePurchaseOfferContext);
  const isBidding = !!listing?.bidding;
  const validateBiddingOfferValidityStart = (rule, value) => {
    const BIDDING_MIN_VALIDITY_TIME_HOURS = 48;
    const BIDDING_MAX_VALIDITY_TIME_HOURS = 360;
    const BIDDING_MIN_VALIDITY_TIME_DAYS = BIDDING_MIN_VALIDITY_TIME_HOURS / 24;
    const BIDDING_MAX_VALIDITY_TIME_DAYS = BIDDING_MAX_VALIDITY_TIME_HOURS / 24;
    const timeAmount = form.getFieldValue('biddingOfferValidityTimeAmount');
    if (!timeAmount || timeAmount && !Number(timeAmount)) {
      return Promise.reject(t('common:Validation:RequiredField'));
    }
    const timeUnit = form.getFieldValue('biddingOfferValidityTimeUnit');
    const timeNumber = Number(timeAmount);
    if (timeUnit === 'hours') {
      if (timeNumber < BIDDING_MIN_VALIDITY_TIME_HOURS) {
        return Promise.reject(t('listing:Bidding.ValidityTimeMustBeMinimum', {
          amount: BIDDING_MIN_VALIDITY_TIME_HOURS,
          unit: t('listing:Bidding.ValidityTimeUnits.hours')
        }));
      }
      if (timeNumber > BIDDING_MAX_VALIDITY_TIME_HOURS) {
        return Promise.reject(t('listing:Bidding.ValidityTimeMustBeMaximum', {
          amount: BIDDING_MAX_VALIDITY_TIME_HOURS,
          unit: t('listing:Bidding.ValidityTimeUnits.hours')
        }));
      }
    }
    if (timeUnit === 'days') {
      if (timeNumber < BIDDING_MIN_VALIDITY_TIME_DAYS) {
        return Promise.reject(t('listing:Bidding.ValidityTimeMustBeMinimum', {
          amount: BIDDING_MIN_VALIDITY_TIME_DAYS,
          unit: t('listing:Bidding.ValidityTimeUnits.days')
        }));
      }
      if (timeNumber > BIDDING_MAX_VALIDITY_TIME_DAYS) {
        return Promise.reject(t('listing:Bidding.ValidityTimeMustBeMaximum', {
          amount: BIDDING_MAX_VALIDITY_TIME_DAYS,
          unit: t('listing:Bidding.ValidityTimeUnits.days')
        }));
      }
    }
    return Promise.resolve();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.OfferValidityTitle')
  }, !isBidding && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DateTimeFields, {
    wrapperItemProps: {
      label: t('listing:PurchaseOffer.OfferValidityDetails1'),
      style: {
        marginBottom: 0
      }
    },
    dateItemProps: {
      name: 'offerValidityDateDeadline',
      rules: [{
        required: true
      }]
    },
    datePickerProps: {
      disabledDate: disablePastDatesAllowToday
    },
    timeItemsProps: {
      name: 'offerValidityTimeDeadline',
      rules: [{
        required: true
      }]
    }
  }), /*#__PURE__*/React.createElement(DixuForm.Item, {
    label: t('listing:PurchaseOffer:OfferValidityDetails2'),
    style: {
      marginTop: 0
    }
  })), isBidding && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuForm.Item, {
    label: t('listing:PurchaseOffer:OfferValidityBiddingDetails1')
  }), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 8],
    style: {
      marginTop: -8
    }
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "biddingOfferValidityTimeAmount",
    rules: [{
      validator: validateBiddingOfferValidityStart
    }]
  }, /*#__PURE__*/React.createElement(DixuInputNumber, {
    width: "100%",
    min: 0,
    hideHandlers: true
  }))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "biddingOfferValidityTimeUnit",
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuSelect, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(DixuSelect.Option, {
    key: "hours",
    value: "hours"
  }, t('listing:PurchaseOffer.TIME_VALUE.HOURS')), /*#__PURE__*/React.createElement(DixuSelect.Option, {
    key: "days",
    value: "days"
  }, t('listing:PurchaseOffer.TIME_VALUE.DAYS')))))), /*#__PURE__*/React.createElement(DixuForm.Item, {
    label: t('listing:PurchaseOffer:OfferValidityBiddingDetails2'),
    style: {
      marginTop: 0
    }
  }))), !isDixuEasy(listing) && /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.DigitalOffer')
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "buyerInterestedInDias",
    rules: [{
      required: true
    }],
    label: t('listing:PurchaseOffer:AreYouInterestedInDias')
  }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
    optionType: "button",
    buttonStyle: "solid",
    block: true,
    options: [{
      value: true,
      label: t('common:Yes')
    }, {
      value: false,
      label: t('common:No')
    }]
  })), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "buyersSameBank",
    shouldUpdate: ['buyerInterestedInDias', 'buyers'],
    visible: () => form.getFieldValue('buyerInterestedInDias') === true && form.getFieldValue('buyers')?.length > 1,
    rules: [{
      required: true
    }],
    label: t('listing:PurchaseOffer:AreYouSameBankCustomers')
  }, /*#__PURE__*/React.createElement(DixuRadio.Group, {
    optionType: "button",
    buttonStyle: "solid",
    block: true,
    options: [{
      value: true,
      label: t('common:Yes')
    }, {
      value: false,
      label: t('common:No')
    }]
  }))))), !isDixuEasy(listing) && /*#__PURE__*/React.createElement(DixuForm.Section, {
    title: t('listing:PurchaseOffer.PrivacyPolicy')
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 16
  }, listing?.realtor?.companyPrivacyProtectionLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuText, {
    block: true
  }, t('listing:PurchaseOffer.PrivacyPolicyUrl')), /*#__PURE__*/React.createElement(DixuLink, {
    active: true,
    href: listing?.realtor?.companyPrivacyProtectionLink,
    external: true
  }, listing?.realtor?.companyPrivacyProtectionLink)), !listing?.realtor?.companyPrivacyProtectionLink && /*#__PURE__*/React.createElement(DixuText, {
    block: true
  }, t('listing:PurchaseOffer.NotAvailable'))))));
};
const Step9 = () => {
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing', 'pdfs']);
  const {
    form,
    purchaseOfferPDFData,
    listing
  } = useContext(CreatePurchaseOfferContext);
  const fullStreetAddress = getFullStreetAddress(listing);
  const purchaseOfferPreview = () => {
    if (!purchaseOfferPDFData) {
      return null;
    }
    return {
      tab: t('listing:PurchaseOffer.PurchaseOffer'),
      content: /*#__PURE__*/React.createElement(DixuPDFViewer, {
        getIframeSrc: async () => getPurchaseOfferPreviewPDF({
          id: purchaseOfferPDFData?.id,
          listingId: listing?.id,
          type: 'PURCHASE_OFFER'
        }),
        fileName: `${t('listing:PurchaseOffer.PurchaseOffer')} ${fullStreetAddress}`
      })
    };
  };
  const PEPPreviews = useMemo(() => {
    const needsPEP = isRealtorListing(listing);
    const {
      buyers
    } = form.getFieldsValue(true);
    if (!needsPEP || !buyers?.length) {
      return [];
    }
    return buyers.map(buyer => {
      const {
        name
      } = buyer;
      return {
        tab: `${t('listing:SignedDocumentTypes.PEP_FORM')} - ${name}`,
        content: /*#__PURE__*/React.createElement(DixuPDFViewer, {
          getIframeSrc: async () => getPurchaseOfferPreviewPDF({
            id: purchaseOfferPDFData.id,
            listingId: listing.id,
            type: 'KYC',
            buyer
          }),
          fileName: `${t('listing:SignedDocumentTypes.PEP_FORM')} ${fullStreetAddress}`
        })
      };
    });
  }, []);
  const previews = [purchaseOfferPreview(), ...PEPPreviews].filter(Boolean);
  if (!previews.length) {
    return null;
  }
  if (previews.length === 1) {
    return previews[0].content;
  }
  const mappedPreviews = previews.map((data, index) => {
    const {
      tab,
      content
    } = data;
    if (!content) {
      return null;
    }
    return /*#__PURE__*/React.createElement(DixuTabs.TabPane, {
      key: index.toString(36),
      tab: tab
    }, content);
  }).filter(Boolean);
  return /*#__PURE__*/React.createElement(DixuTabs, {
    tabBarMargin: false
  }, mappedPreviews);
};
const Step10 = () => {
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    purchaseOffer,
    flow
  } = useContext(CreatePurchaseOfferContext);
  return /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 32]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "3",
    align: "center",
    weight: "bold",
    margin: "0",
    noSemantics: true
  }, t('listing:PurchaseOffer:YouHaveSentThisPurchaseOffer'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuButton.Group, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    shadow: "1",
    href: purchaseOffer?.signicatBuyerTasks?.[0]?.url,
    external: true,
    target: "_self"
  }, t('listing:PurchaseOffer:ClickHereToSign')), /*#__PURE__*/React.createElement(DixuButton, {
    type: "link",
    onClick: () => flow.goToStep(0)
  }, t('listing:PurchaseOffer:YouCanAlsoEditPurchaseOffer')))));
};
const DixuCreatePurchaseOfferModal = _ref7 => {
  let {
      listing,
      purchaseOffer: initialPurchaseOffer,
      counterOfferForID,
      visible,
      onCancel
    } = _ref7,
    rest = _objectWithoutProperties(_ref7, _excluded);
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    user
  } = useContext(AppContext);
  const [form] = DixuForm.useForm();
  const [flow] = DixuStepFlow.useFlow();
  const {
    0: purchaseOffer,
    1: setPurchaseOffer
  } = useState(deserializePurchaseOffer(initialPurchaseOffer, listing));
  const {
    id: purchaseOfferID
  } = purchaseOffer;
  const isCounterOffer = !!counterOfferForID;
  const {
    id: listingID,
    bidding,
    realtor
  } = listing || {};
  const isBidding = !!bidding;
  const {
    0: purchaseOfferPDFData,
    1: setPurchaseOfferPDFData
  } = useState();
  const [saveProgress, isSavingProgress] = useIsLoading(async function () {
    let {
      direction = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const allValues = form.getFieldsValue(true);
    try {
      const data = serializePurchaseOffer(_objectSpread(_objectSpread({}, allValues), {}, {
        currentCreateFlowStep: flow.currentStep + direction,
        purchaseOfferID
      }), listing);
      if (!isStorybookEnv) {
        if (isCounterOffer) {
          await saveCounterPurchaseOfferDraft({
            counterOfferID: purchaseOfferID,
            data
          });
        } else {
          await savePurchaseOfferDraft({
            listingID,
            data
          });
        }
      }
      return Promise.resolve();
    } catch (error) {
      DixuNotification.error({
        message: 'Tallentaminen epäonnistui',
        description: getErrorDescription(error)
      });
      return Promise.reject(error);
    }
  });
  const [signOffer, isSigningOffer, isSigningOfferRef] = useIsLoading(async () => {
    try {
      if (isCounterOffer) {
        const redirectURL = await get(`/api/sign/${listingID}/counter-offer/${purchaseOfferID}`);
        redirect(redirectURL, {
          hard: true
        });
      } else {
        const redirectURL = await get(`/api/sign/purchase-offer/${listingID}`);
        redirect(redirectURL, {
          hard: true
        });
      }
      return new Promise(() => {});
    } catch (error) {
      DixuNotification.error({
        message: 'Allekirjoituksen aloittaminen epäonnistui',
        description: getErrorDescription(error)
      });
      return Promise.reject(error);
    }
  });
  const [confirmClose] = useConfirmUnload({
    shouldConfirm: () => !isSigningOfferRef.current && visible && form.isFieldsTouched()
  });
  const createPDFPurchaseOffer = () => {
    const values = form.getFieldsValue(true);
    const serialized = serializePurchaseOffer(values, listing);
    setPurchaseOfferPDFData(serialized);
  };
  const getRealtorInfo = function () {
    let {
      defaultOpen = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!isRealtorListing(listing) || !realtor) {
      return null;
    }
    const icon = /*#__PURE__*/React.createElement(DixuText, {
      font: "5",
      color: "1-6"
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, null));
    return /*#__PURE__*/React.createElement("div", {
      className: "m-b-16"
    }, /*#__PURE__*/React.createElement(DixuCollapse, {
      defaultActiveKey: defaultOpen ? '0' : undefined
    }, /*#__PURE__*/React.createElement(DixuCollapse.Panel, {
      header: /*#__PURE__*/React.createElement(DixuRow, {
        gutter: 18,
        wrap: false
      }, /*#__PURE__*/React.createElement(DixuCol, {
        flex: "0 0 auto"
      }, icon), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
        font: "3",
        color: "2-9",
        weight: "normal"
      }, "Her\xE4sik\xF6 sinulle kysymyksi\xE4 tarjouksen laadintaan liittyen? Kohteen v\xE4litt\xE4j\xE4 on apunasi.")))
    }, /*#__PURE__*/React.createElement(DixuRow, {
      gutter: 18,
      wrap: false
    }, /*#__PURE__*/React.createElement(DixuCol, {
      flex: "0 0 auto",
      style: {
        visibility: 'hidden'
      }
    }, icon), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRealtorInfo, {
      realtor: realtor,
      listing: listing
    }))))));
  };
  const handleCancel = () => {
    if (isSavingProgress || isSigningOffer) {
      return;
    }
    if (confirmClose()) {
      onCancel?.();
    }
  };
  const [fetchPurchaseOffer, isFetchingPurchaseOffer] = useIsLoading(async () => {
    try {
      if (isCounterOffer) {
        return getCounterPurchaseOfferDraft({
          offerID: counterOfferForID
        });
      }
      return getPurchaseOffer({
        listingID
      });
    } catch (error) {
      DixuNotification.error({
        message: 'Ostotarjouksen hakeminen epäonnistui',
        description: getErrorDescription(error)
      });
      return Promise.reject(error);
    }
  });
  useEffect(() => {
    if (initialPurchaseOffer || !visible || !listing?.id) {
      return undefined;
    }
    let isMounted = true;
    (async () => {
      try {
        const data = await fetchPurchaseOffer();
        if (isMounted) {
          const deserialized = deserializePurchaseOffer(data, listing);
          setPurchaseOffer(deserialized);
        }
      } catch (error) {
        DixuNotification.error({
          message: 'Tarjousluonnoksen hakeminen epäonnistui',
          description: getErrorDescription(error)
        });
        handleCancel();
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [listing?.id, visible, initialPurchaseOffer]);
  useEffect(() => {
    form.setFieldsValue(_objectSpread(_objectSpread({}, purchaseOffer), {}, {
      buyers: (() => {
        if (purchaseOffer?.buyers?.length) {
          return purchaseOffer.buyers;
        }
        return [{
          name: user?.displayName,
          ssn: user?.snn,
          address: user?.address,
          email: user?.emails?.[0]?.value,
          tel: user?.tel
        }];
      })()
    }));
  }, [purchaseOffer]);
  useAfterInitialRender(() => {
    const {
      status,
      offerValidityDateDeadline,
      riskResponsibility,
      maintenanceChargesSellerLastDay,
      apartmentControlChangeDateDeadline,
      currentCreateFlowStep
    } = purchaseOffer || {};
    form.setFieldsValue({
      propertyDocuments: Object.values(ApartmentPurchaseOfferDocumentTypes).map(key => ({
        documentName: key
      })).map(document => _objectSpread(_objectSpread({}, document), purchaseOffer?.propertyDocuments?.find(incomingData => incomingData?.documentName === document?.documentName) || {}))
    });

    // TODO
    // Update API to support draft offer with possible faulty data and
    // remove other than the first 2 if-cases below.
    if (status === OFFER_STATUS.COUNTER_OFFER_DRAFT) {
      flow.goToStep(1);
    } else if (currentCreateFlowStep) {
      if (currentCreateFlowStep === 7) {
        createPDFPurchaseOffer();
      }
      flow.goToStep(currentCreateFlowStep);
    } else if (status === OFFER_STATUS.WAITING_FOR_BUYER_SIGNATURES) {
      flow.goToStep(8);
    } else if (offerValidityDateDeadline) {
      flow.goToStep(5);
    } else if (riskResponsibility) {
      flow.goToStep(4);
    } else if (maintenanceChargesSellerLastDay) {
      flow.goToStep(3);
    } else if (apartmentControlChangeDateDeadline) {
      flow.goToStep(2);
    }
  }, [purchaseOffer]);
  const steps = [/*#__PURE__*/React.createElement(Step1, null), /*#__PURE__*/React.createElement(Step2, null), /*#__PURE__*/React.createElement(Step3, null), /*#__PURE__*/React.createElement(Step4, null), /*#__PURE__*/React.createElement(Step5, null), /*#__PURE__*/React.createElement(Step6, null), /*#__PURE__*/React.createElement(Step7, null), /*#__PURE__*/React.createElement(Step8, null), /*#__PURE__*/React.createElement(Step9, null), /*#__PURE__*/React.createElement(Step10, null)];
  const mappedSteps = steps.map((step, index) => {
    return /*#__PURE__*/React.createElement(DixuStepFlow.Step, {
      key: index.toString(36)
    }, step);
  });
  const title = (() => {
    const textI18nKey = isCounterOffer ? 'listing:PurchaseOffer.MakeNewCounterOffer' : 'listing:PurchaseOffer.MakeNewPurchaseOffer';
    if (flow.currentStep > 6) {
      return t(textI18nKey);
    }
    return `${t(textI18nKey)} ${flow.currentStep + 1}/${flow.stepCount - 1}`;
  })();
  const footer = /*#__PURE__*/React.createElement(DixuButton.Group, {
    spacing: "sm",
    justify: "end"
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    onClick: handleCancel,
    disabled: isSavingProgress || isSigningOffer
  }, t('common:Cancel')), flow.currentStep > 0 && /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    disabled: isSavingProgress || isSigningOffer,
    onClick: () => {
      form.validateFields().then(() => saveProgress({
        direction: -1
      })).then(() => form.validateFields()).then(() => flow.goToPreviousStep()).catch(() => {});
    }
  }, t('common:Previous')), flow.currentStep < 7 && /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    loading: isSavingProgress,
    disabled: isSigningOffer,
    onClick: () => {
      form.validateFields().then(() => saveProgress({
        direction: 1
      })).then(() => form.validateFields()).then(() => flow.goToNextStep()).catch(() => {});
    }
  }, t('common:Next')), flow.currentStep === 7 && /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    disabled: isSavingProgress || isSigningOffer,
    onClick: () => {
      form.validateFields().then(() => saveProgress()).then(() => form.validateFields()).then(() => {
        createPDFPurchaseOffer();
        flow.goToNextStep();
      }).catch(() => {});
    }
  }, t('listing:PurchaseOffer.ContinueToPreview')), flow.currentStep === 8 && /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    loading: isSavingProgress || isSigningOffer,
    onClick: () => {
      saveProgress().then(() => signOffer()).catch(() => {});
    }
  }, t('listing:PurchaseOffer.StartSigningProcessAndSendPurchaseOffer')));
  const context = {
    listing,
    purchaseOffer,
    counterOfferForID,
    isCounterOffer,
    isBidding,
    form,
    getRealtorInfo,
    purchaseOfferPDFData,
    flow
  };
  return /*#__PURE__*/React.createElement(CreatePurchaseOfferContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(DixuModal, _objectSpread(_objectSpread({}, rest), {}, {
    visible,
    title,
    onCancel: handleCancel,
    footer: isFetchingPurchaseOffer || !purchaseOffer ? null : footer,
    width: flow.currentStep === 8 ? 826 : 700,
    loading: isSavingProgress || isFetchingPurchaseOffer || isSigningOffer
  }), /*#__PURE__*/React.createElement(DixuForm, {
    form: form,
    name: "purchase-offer"
  }, /*#__PURE__*/React.createElement(DixuStepFlow, {
    flow: flow,
    scrollTargetYOffset: "-24"
  }, mappedSteps))));
};
DixuCreatePurchaseOfferModal.defaultProps = {
  counterOfferForID: undefined,
  purchaseOffer: undefined
};
export default DixuCreatePurchaseOfferModal;